<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.512 7.60958C10.7622 7.80974 10.7622 8.19028 10.512 8.39045L6.81235 11.3501C6.48496 11.612 6 11.3789 6 10.9597L6 5.04031C6 4.62106 6.48497 4.38797 6.81235 4.64988L10.512 7.60958Z" fill="currentColor"/>
</svg>
